import { render, staticRenderFns } from "./LocationSVG.vue?vue&type=template&id=3aaae10c&scoped=true&"
import script from "./LocationSVG.vue?vue&type=script&lang=js&"
export * from "./LocationSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaae10c",
  null
  
)

export default component.exports